import { Component, OnDestroy, OnInit } from "@angular/core";
import { Observable, Subscription } from "rxjs";
import { PanelDetailRouteService } from "../../services/Panel-Detail-Route.service";
import { PanelResumeRouteService } from "../../services/Panel-Resume-Route.service";
import { GroupStepRouteDTO } from "../../models/GroupStepRouteDTO";
import { MapHelperService } from "../../../../../services/map-helper.service";
import { StepRouteDTO } from "../../models/StepRouteDTO";

@Component({
  selector: "panel-detail-routeSteps",
  templateUrl: "./panel-detail-routeSteps.component.html",
  styleUrls: ["./panel-detail-routeSteps.component.css"],
})
export class PanelDetailRouteStepsComponent implements OnInit, OnDestroy {
  elements: number;
  isLoading: boolean = false;
  isVisibleDetails: boolean;
  public $isVisibleDetails: Observable<boolean> = new Observable<boolean>();
  isAdmin: boolean;
  roles: any;
  sDateRoute: string = "Detalle de Movimientos";
  selectedTabIndex: number;
  groupStepsRouteDTO: GroupStepRouteDTO[];
  shownDate: string = "";
  shownFirst = false;
  isSelectedGroup: boolean = false;

  constructor(
    private panelDetailRouteService: PanelDetailRouteService,
    private panelResumeRouteService: PanelResumeRouteService,
    private mapHelperService: MapHelperService
  ) {
    this.recuperateResume();
  }

  ngOnInit(): void {}

  ngOnDestroy() {}

  recuperateResume() {
    console.log("Recuperation on progress");
    this.groupStepsRouteDTO = this.panelResumeRouteService.groupStepsRouteDTO;
    console.log("grupos", this.groupStepsRouteDTO);
  }

  onClickGroup(idGroup) {
    console.log("onClickGroup", idGroup);
    this.SwitchLayerStep(idGroup);
  }

  SwitchLayerStep(idGroup) {
    this.isSelectedGroup = !this.isSelectedGroup;
    console.log("isSelectedGroup", this.isSelectedGroup);

    //Limpia el resumen
    console.log("FINDING ....");
    console.log(idGroup);
    console.log(this.groupStepsRouteDTO);
    const groupStep = this.groupStepsRouteDTO.filter(function (d) {
      return d.idGroup == idGroup;
    });
    console.log(groupStep);
    if (groupStep.length > 0) {
      //Actualizar capa de Grupo
      this.mapHelperService.UpdateLayerGeoJson(
        "routeGroupStep",
        JSON.parse(groupStep[0].sGroupStepGeojson)
      );

      this.mapHelperService.SetBounds(
        JSON.parse(groupStep[0].sGroupStepGeojson)
      );
      this.mapHelperService.HideLayer("routeResume-line-layer");
      this.mapHelperService.ShowLayer("routeResume-lineOpacityMin-layer");
    }
  }

  onClickStep(detail: StepRouteDTO, idGroup) {
    var latitude = detail.latitude;
    var longitude = detail.longitude;
    console.log("clicking step", detail);
    if(detail.statusVehicle == "Encendido" || detail.statusVehicle == "Apagado"){
      console.log("fly to", longitude,latitude);
      this.mapHelperService.FlyToCameraFast(longitude,latitude,"21");
    }else{
      console.log("switch layer");
      this.SwitchLayerStep(idGroup);
    }
  }

  CancelButton() {
    this.panelDetailRouteService.setVisibilityPopup(false);
    console.log("cerrando popup");
  }

  getTimePeriod(time: string) {
    var hours = time.split(":")[0];
    var minutes = time.split(":")[1];

    if (Number.parseInt(hours) > 12) {
      return Number.parseInt(hours) - 12 + ":" + minutes + " PM";
    } else {
      if (Number.parseInt(hours) == 12) return hours + ":" + minutes + " PM";

      return hours + ":" + minutes + " AM";
    }
  }

  setGroupStepsRouteDate(value: string): string {
    this.shownDate = value;
    this.shownFirst = true;
    
    return this.shownDate; 
  }
}
